import Topics from "./Topics";
import { Heading } from "@chakra-ui/react";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { useQuery } from "react-query";
import { getProgramById } from "API/programApi";

interface SubjectProps {
  subject: ISubject;
  setvideosrc: (videosrc: string | undefined) => void;
  setPlayingVideoId: (videosrc: string | undefined) => void;
  playingVideoId: string | undefined;
  isdefaultavailable: boolean;
  setisdefaultavailable: (isdefaultvideoavailable: boolean) => void;
}

const Subject: FC<SubjectProps> = ({
  subject,
  setvideosrc,
  playingVideoId,
  setPlayingVideoId,
  isdefaultavailable,
  setisdefaultavailable,
}) => {
  const { id } = useParams<{ id: string }>();
  const { data: program } = useQuery<IProgram>(
    ["program", id, subject?._id],
    () => getProgramById(id, subject?._id)
  );
  const [shouldshowsubject, setshouldshowsubject] = useState(false);
  useEffect(() => {
    const videourls: (string | undefined)[] = [];
    program?.chapters.forEach((chapter) => {
      chapter.topics.forEach((topic) => {
        videourls.push(topic.videolink);
      });
    });
    if (videourls.length > 0) {
      setshouldshowsubject(true);
    }
  }, [program]);
  return (
    <>
      {shouldshowsubject ? (
        <>
          {" "}
          <Heading
            textTransform={"capitalize"}
            size="md"
            padding={["2", "20px"]}
          >
            {subject?.name}
          </Heading>
          <Topics
            subjId={subject?._id}
            setvideosrc={setvideosrc}
            setPlayingVideoId={setPlayingVideoId}
            playingVideoId={playingVideoId}
            isdefaultavailable={isdefaultavailable}
            setisdefaultavailable={setisdefaultavailable}
          />
        </>
      ) : null}
    </>
  );
};
export default Subject;
